export const RELEASE_LINE = {
  angular: '5.2.x',
  packageVersion: '5.0.0',
  coreVersion: '0.1.1',
  runtimeTarget: 'Angular 5 + Angular CLI',
  docsPath: '/angular-5/'
};



// WEBPACK FOOTER //
// ./src/app/data/release-line.ts